import {
	EngineCommunicationChannels,
	LoggerAction,
	StorageUploadFileChannel,
} from '@webitel/api-services/gen/models';
import { RingtoneType } from '@webitel/ui-sdk/enums';
import { NotificationType } from '../../../modules/settings/modules/notifications/enums/NotificationType';

export default {
	auth: {
		register: 'Đăng ký',
		login: 'Đăng nhập',
		registerReset: 'Đặt lại mật khẩu',
		detailsSubtitle: 'Nhập thông tin của bạn bên dưới',
		resetPasswordLink: 'Quên mật khẩu?',
		user: 'Tên đăng nhập',
		password: 'Mật khẩu',
		confirmPassword: 'Nhập lại mật khẩu',
		key: 'Mã giấy phép',
		registerSubmit: 'Đăng ký',
		resetSubmit: 'Đặt lại',
		loginSubmit: 'Đăng nhập',
		carousel: {
			title1: 'Đám mây vs. Tại chỗ',
			text1:
				'Chính sách bảo mật không cho phép lưu trữ dữ liệu và sử dụng dịch vụ đám mây? Với Webitel, bạn có thể xây dựng trung tâm liên hệ tại chỗ!',

			title2: 'Đa kênh VS Omni-Channel',
			text2:
				'Luôn luôn và ở mọi nơi kết nối với khách hàng của bạn! IVR-menu với mọi mức độ phức tạp, chiến dịch tương tác ra vào hoặc nhắn tin trên mạng xã hội - giờ đây dễ dàng hơn bao giờ hết!',

			title3: 'Hạ tầng chịu lỗi',
			text3:
				'Không còn thời gian chết ngoài ý muốn. Kiến trúc mở rộng nhanh và chịu lỗi cho phép bạn phục vụ đồng thời hơn 1000 cuộc gọi khách hàng mỗi phút từ các kênh liên lạc khác nhau.',

			title4: 'Thiết kế',
			text4:
				'Giao diện tối giản mới với bảng điều khiển quản trị thân thiện nhất, cho phép bạn truy cập nhanh vào tất cả các chức năng cần thiết. Ít nhấp chuột hơn - nhiều tính năng hơn.',

			title5: 'Mô-đun làm việc nhóm đại lý mới',
			text5:
				'Phân phối cuộc gọi hiệu quả nhất. Một đại lý có thể có nhiều kỹ năng để tham gia các chiến dịch khác nhau. Khách hàng chỉ được phục vụ bởi các chuyên gia.',

			title6: 'Thiết lập quyền',
			text6:
				'Mô-đun quản lý quyền mới - cơ hội kiểm soát mới. Người dùng chỉ có thể thay đổi các phần cũng như các hành động.',
		},
	},

	header: {
		logout: 'Đăng xuất',
		docs: 'Tài liệu',
	},

	appNavigator: {
		title: 'Ứng dụng Webitel',
		admin: 'Quản trị viên',
		agent: 'Không gian làm việc của đại lý',
		supervisor: 'Không gian làm việc của giám sát',
		audit: 'Kiểm toán',
		history: 'Lịch sử cuộc gọi',
		grafana: 'Grafana',
	},

	settings: {
		settings: 'Cài đặt',
		changePassword: 'Đổi mật khẩu',
		language: 'Ngôn ngữ',
		fallbackLanguage: 'Ngôn ngữ mặc định',
		webPhone: 'Điện thoại Web',
		useWebPhone: 'Sử dụng điện thoại Web',
		useStun: 'Sử dụng STUN',
		notifications: {
			[NotificationType.NewMessageSound]: 'Âm thanh tin nhắn mới',
			[NotificationType.NewChatSound]: 'Âm thanh chat mới',
			[NotificationType.SelfAssignedCallSound]: 'Âm thanh cuộc gọi tự nhận',
			[NotificationType.ChatEndSound]: 'Âm thanh kết thúc chat',
			[NotificationType.CallEndSound]: 'Âm thanh kết thúc cuộc gọi',
			[NotificationType.TaskEndSound]: 'Âm thanh kết thúc nhiệm vụ',
			[NotificationType.ChatEndPush]: 'Thông báo đẩy kết thúc chat',
			[NotificationType.CallEndPush]: 'Thông báo đẩy kết thúc cuộc gọi',
			[NotificationType.TaskEndPush]: 'Thông báo đẩy kết thúc nhiệm vụ',
			[NotificationType.SocketCloseSound]: 'Âm thanh mất kết nối',
		},
		ringtones: {
			title: 'Thay đổi nhạc chuông cuộc gọi',
			ringtone: 'Nhạc chuông',
			customRingtone: 'Sử dụng nhạc chuông tùy chỉnh',
		},
		ringtoneVolume: {
			title: 'Cài đặt âm lượng',
			[RingtoneType.Call]: 'Cuộc gọi',
			[RingtoneType.Chat]: 'Trò chuyện',
			[RingtoneType.Task]: 'Nhiệm vụ',
		},
		security: {
			security: 'Bảo mật',
			logoutTitle: 'Đăng xuất người dùng này khỏi các thiết bị khác',
		},
	},

	validation: {
		email: 'Phải giống email',
		required: 'Trường này là bắt buộc',
		sameAs: 'Mật khẩu không đúng',
		gatewayHostValidator: 'Phải giống IPv4 hoặc FQDN',
		ipValidator: 'Phải giống IPv4',
		macValidator: 'Phải giống MAC',
		numeric: 'Phải là số',
		requiredArrayValue: 'Mảng không được rỗng',
		isPositiveValue: 'Giá trị phải là số dương',
		cron: 'Biểu thức cron không hợp lệ',
		hourRange: 'Giờ phải từ 00 đến 23',
		timerangeStartLessThanEnd: 'Thời gian "Từ" không được muộn hơn "Đến"',
		timerangeNotIntersect:
			'Các khoảng thời gian trong cùng một ngày không được chồng chéo',
	},

	nav: {
		directory: {
			directory: 'Danh bạ',
		},
		routing: {
			routing: 'Định tuyến',
		},
		lookups: {
			lookups: 'Tra cứu',
		},
		ccenter: {
			ccenter: 'Trung tâm liên hệ',
		},
		integrations: {
			integrations: 'Tích hợp',
		},
		permissions: {
			permissions: 'Quyền',
		},
		system: {
			system: 'Hệ thống',
		},
	},

	home: {
		dashboard: 'Bảng điều khiển',
		welcomeText: '',
		news: 'Tin tức',
	},

	objects: {
		all: 'Tất cả {entity}',
		administration: 'Quản lý',
		general: 'Tổng quát',
		new: 'Mới',
		add: 'Thêm',
		create: 'Tạo',
		read: 'Đọc',
		edit: 'Sửa',
		delete: 'Xóa',
		save: 'Lưu',
		saved: 'Đã lưu',
		saveAs: 'Lưu dưới dạng',
		close: 'Đóng',
		next: 'Tiếp',
		back: 'Quay lại',
		change: 'Thay đổi',
		name: 'Tên',
		title: 'Tiêu đề',
		description: 'Mô tả',
		user: 'Người dùng',
		users: 'Người dùng',
		action: 'Hành động',
		allow: 'Cho phép',
		password: 'Mật khẩu',
		history: 'Lịch sử',
		copy: 'Sao chép',
		copied: 'Đã sao chép vào bảng từ điển!',
		createdAt: 'Đã tạo',
		createdBy: 'Đã tạo bởi',
		online: 'Trực tuyến',
		offline: 'Ngoại tuyến',
		on: 'Bật',
		off: 'Tắt',
		ok: 'Đồng ý',
		enabled: 'Đã bật',
		status: 'Trạng thái',
		from: 'Từ',
		to: 'Đến',
		importJSON: 'Nhập JSON',
		addNew: 'Thêm mới',
		provider: 'Nhà cung cấp',
		default: 'Mặc định',
		service: 'Dịch vụ',
		tts: 'Dịch vụ chuyển đổi văn bản thành giọng nói',
		stt: 'Dịch vụ chuyển đổi giọng nói thành văn bản',
		key: 'Khóa',
		ID: 'ID',
		email: ({ linked }) => linked('vocabulary.emails'),
		updatedAt: 'Đã sửa',
		emptyWorkspace: 'Chưa có bản ghi nào',
		emptyResultSearch: 'Tìm kiếm của bạn không cho kết quả',

		deleteConfirmation: {
			title: 'Xác nhận xóa',
			askingAlert:
				'Bạn có chắc chắn muốn xóa {count} mục? | Bạn có chắc chắn muốn xóa {count} mục?',
			undoneActionAlert: 'Hành động này không thể hoàn tác.',
			deleteAll: 'TẤT CẢ',
		},
		generalInfo: 'Thông tin tổng quát',
		objectHeader: {},
		directory: {
			directory: 'Danh bạ',
			passwordInfo:
				'Nhập giá trị chỉ khi bạn muốn chỉnh sửa nó (hoặc tạo mới). Trường trống sẽ để lại giá trị không đổi',
			users: {
				users: 'Người dùng',
				allUsers: 'Tất cả người dùng',
				searchPlaceholder: 'Tên, đăng nhập, mở rộng, trạng thái',
				login: 'Đăng nhập',
				extensions: 'Mở rộng',
				state: 'Trạng thái',
				DnD: 'DnD',
				status: 'Trạng thái',
				roles: 'Vai trò',
				tokens: 'Mã thông báo',
				usage: 'Sử dụng',
				expiryDays: 'Số ngày hiệu lực',
				expiryDate: 'Ngày hết hạn',
				roleAdmin: 'Quản trị viên',
				license: 'Giấy phép',
				devices: 'Thiết bị',
				defaultDevice: 'Thiết bị mặc định (từ danh sách thiết bị đã chọn)',
				deviceNotFound: 'Không tìm thấy thiết bị?',
				createNewDevice: 'Thêm mới',
				variables: 'Biến',
				varKey: 'Khóa',
				varVal: 'Giá trị',
				token: 'Mã thông báo',
				tokenPopupHeader: 'Mã thông báo của bạn đã được tạo thành công!',
				tokenPopupText:
					'Tải xuống tệp khóa của bạn ngay bây giờ hoặc sao chép nó. Nếu bạn không tải tệp khóa ngay bây giờ, bạn sẽ không thể lấy lại mã thông báo của mình. Để bảo vệ an toàn của bạn, lưu trữ mã thông báo của bạn an toàn và không chia sẻ nó.',
				tokenPopupCopy: 'Sao chép vào bảng từ điển',
				tokenPopupSave: 'Lưu dưới dạng TXT',
				userIp: 'Địa chỉ IP của người dùng',
				userId: 'ID người dùng',
				download: 'Tải xuống',
				regenerate: 'Tạo lại',
				askingAlert:
					'Bạn có chắc chắn muốn tạo lại mã không? Người dùng sẽ không thể đăng nhập',
				chatName: 'Tên hiển thị trò chuyện',
				temporaryPassword: 'Mật khẩu tạm thời',
				communications: 'Liên lạc',
				generateDevice: 'Tạo thiết bị',
				deviceGenerationTitle: 'Tạo thiết bị',
				deviceGeneration:
					'Hành động này sẽ tự động tạo một thiết bị mới cho người dùng này.',
				deviceWasGenerated: 'Thiết bị đã được tạo',
				deviceGenerationConfirmTitle: 'Xác nhận tạo thiết bị',
				generateDeviceConfirmation:
					'Các thiết bị hiện tại sẽ được thay thế bằng thiết bị được tạo. Tiếp tục?',
				authorizationSecurity: 'Ủy quyền và bảo mật',
				mustChangePassword:
					'Người dùng phải thay đổi mật khẩu trong lần đăng nhập đầu tiên.',
				extensionsHelperText: 'Số nội bộ chỉ được chứa chữ số',
				csvMappingFields: {
					login: ({ linked }) => linked('vocabulary.login'),
					name: 'Tên',
					extension: ({ linked }) =>
						linked('objects.directory.users.extensions'),
					email: ({ linked }) => linked('vocabulary.emails'),
				},
				logout: {
					endAllSessions: 'Kết thúc tất cả phiên',
					endAllMySessions: 'Kết thúc tất cả phiên của tôi',
					endSessionConfirmation: 'Xác nhận kết thúc phiên',
					endSessionConfirmationText:
						'Bạn có chắc muốn kết thúc tất cả các phiên không?',
					endMultipleSessionsConfirmationText:
						'Bạn có chắc chắn muốn kết thúc tất cả các phiên cho {count} người dùng không?',
					tooltip: 'Người dùng sẽ bị đăng xuất khỏi tất cả các thiết bị',
				},
			},
			license: {
				customers: 'Khách hàng',
				license: 'Giấy phép',
				licenseId: 'ID',
				allCustomers: 'Tất cả khách hàng',
				allLicenses: 'Tất cả giấy phép',
				serial: 'Số seri',
				product: 'Sản phẩm',
				validFrom: 'Hạn sử dụng từ',
				validTill: 'Hạn sử dụng đến',
				used: 'Đã sử dụng',
				limit: 'Giới hạn',
				status: 'Trạng thái',
				competitive: 'Cạnh tranh',
				searchPlaceholder: 'Số seri, sản phẩm',
				domain: 'Miền',
				daysToExpire: {
					0: 'Hết hạn',
					30: '30 hoặc ít hơn',
					90: '90 hoặc ít hơn',
					days: ' ngày',
				},
				importLicense: 'Nhập giấy phép',
				licenseKey: 'Mã giấy phép',
			},
			devices: {
				devices: 'Thiết bị',
				newDevice: 'Thiết bị mới',
				newDeviceDescription: 'Mô tả thiết bị mới',
				allDevices: 'Tất cả thiết bị',
				searchPlaceholder: 'Tên, người dùng, ID xác thực & ID bàn',
				authId: 'ID xác thực',
				presence: 'Presence',
				hotdesk: 'Hot desking',
				hotdeskDevice: 'Thiết bị hot desking',
				hotdeskDeviceSettings: 'Cài đặt thiết bị hot desking',
				hotdeskIncorrectInput: 'Tên Host không hợp lệ',
				hotdeskInputHint:
					'Để dễ dàng nhận biết thiết bị này, bạn nên che lấp nó với các biệt danh hot-desk thân thiện. Tên hợp lệ phải chứa các ký tự sau: A-Z, a-z, 0-9, -, _',
				deviceSettings: 'Cài đặt thiết bị',
				hostName: 'Tên Host',
				phoneInfo: 'Thông tin điện thoại',
				phone: 'Điện thoại',
				vendor: 'Nhà cung cấp',
				model: 'Mô hình',
				ipv4: 'IPv4',
				mac: 'MAC',
				deviceHistory: 'Lịch sử thiết bị',
				loggedIn: 'Đã đăng nhập',
				loggedOut: 'Đã đăng xuất',
				state: {
					nonreg: 'Chưa đăng ký',
					reged: 'Đã đăng ký',
					ringing: 'Đang gọi',
					dialing: 'Đang gọi',
					dialog: 'Trò chuyện',
					onhold: 'Đang giữ',
				},
				passwordSetFromAccount:
					'Nếu bạn không đặt mật khẩu, nó sẽ giống như tài khoản',
				csvMappingFields: {
					account: ({ linked }) => linked('webitelUI.headerActions.account'),
					name: ({ linked }) => linked('reusable.name'),
					password: ({ linked }) => linked('vocabulary.password'),
					vendor: 'Nhà sản xuất',
					model: 'Mẫu',
					mac: 'Địa chỉ MAC',
					ip: 'Địa chỉ IP',
				},
			},
		},
		permissions: {
			permissions: 'Quyền',
			permissionsRole: 'Vai trò',
			allRoles: 'Tất cả vai trò',
			searchPlaceholder: 'vai trò ..',
			roles: {
				permissions: {
					permissions: 'Quyền hạn vai trò',
					add: 'Thêm',
					delete: 'Xóa',
					read: 'Chọn',
					write: 'Cập nhật',
					eavesdropCall: 'Nghe lén cuộc gọi',
					playbackRecordFile: 'Phát lại tệp ghi âm',
					timeLimitedRecordFile: 'Phát lại tệp ghi âm thời gian giới hạn',
					resetActiveAttempts: 'Đặt lại các nỗ lực hoạt động',
					limitWorkspaceContacts: 'Giới hạn liên hệ trong Workspace',
					exportDataGrid: 'Xuất dữ liệu bảng',
					viewCdrPhoneNumbers: 'Xem số điện thoại CDR',
					manageUserRoles: 'Quản lý vai trò người dùng',
					manageUserLicense: 'Quản lý giấy phép người dùng',
					changeUserPassword: 'Đổi mật khẩu người dùng',
					systemSetting: 'Quản lý cấu hình hệ thống',
					addDescription: 'Cấp quyền để tạo bất kỳ đối tượng nào',
					deleteDescription: 'Cấp quyền để xóa bất kỳ đối tượng nào',
					readDescription: 'Cấp quyền để chọn bất kỳ đối tượng nào',
					writeDescription: 'Cấp quyền để sửa đổi bất kỳ đối tượng nào',
					eavesdropCallDescription:
						'Cấp quyền để nghe lén cuộc trò chuyện đang hoạt động',
					playbackRecordFileDescription:
						'Cấp quyền để phát lại các tệp ghi âm cuộc gọi',
					timeLimitedRecordFileDescription:
						'Cấp quyền để phát lại các tệp ghi âm cuộc gọi thời gian giới hạn',
					resetActiveAttemptsDescription:
						'Cấp quyền để đặt lại các nỗ lực hoạt động',
					limitWorkspaceContactsDescription:
						'Giới hạn quyền để xem danh sách liên hệ trong Workspace',
					exportDataGridDescription: 'Cấp quyền để xuất dữ liệu bảng vào tệp',
					viewCdrPhoneNumbersDescription: 'Xem số điện thoại CDR',
					manageUserRolesDescription:
						'Cấp quyền để quản lý một tập hợp vai trò người dùng',
					manageUserLicenseDescription:
						'Cấp quyền để quản lý một tập hợp giấy phép người dùng',
					changeUserPasswordDescription: 'Cấp quyền để đổi mật khẩu người dùng',
					systemSettingDescription:
						'Cấp quyền để truy cập và quản lý phần Cấu hình',
					schemeVariables: 'Quản lý biến toàn cầu',
					controlAgentScreen: 'Điều khiển màn hình đại lý',
					schemeVariablesDescription:
						'Cấp quyền để truy cập và quản lý phần Biến toàn cầu',
				},
				addPermission: 'Thêm quyền hạn vai trò',
				usage: 'Sử dụng',
				applicationsAccess: {
					applicationsAccess: 'Truy cập ứng dụng',
					access: 'Truy cập',
				},
			},
			object: {
				object: 'Đối tượng',
				allObjects: 'Tất cả đối tượng',
				ObAC: 'Được quản lý bởi hoạt động',
				RbAC: 'Được quản lý bởi ghi chép',
				operations: 'Hoạt động',
				searchPlaceholder: 'đối tượng ..',
				newPermissionRole: 'Người được cấp quyền',
				rbacDefault: 'Truy cập mặc định dựa trên ghi chép',
				grantor: 'Người cấp quyền',
				grantee: 'Người được cấp quyền',
				create: 'Tạo',
				delete: 'Xóa',
				accessMode: {
					1: 'Từ chối',
					2: 'Cho phép',
					3: 'Cho phép với ủy quyền',
				},
			},
		},
		lookups: {
			lookups: 'Tra cứu',
			skills: {
				skills: 'Kỹ năng',
				capacity: 'Khả năng',
				minCapacity: 'Khả năng tối thiểu',
				minCapacityLessOrEqualToMaxCapacityValidator:
					'Phải nhỏ hơn hoặc bằng khả năng tối đa',
				maxCapacity: 'Khả năng tối đa',
				maxCapacityMoreOrEqualToMinCapacityValidator:
					'Phải lớn hơn hoặc bằng khả năng tối thiểu',
				lvl: 'Cấp độ',
				agentSkills: 'Kỹ năng đại lý',
				allSkills: 'Tất cả kỹ năng',
				state: 'Trạng thái',
				stateForAll: 'Trạng thái cho tất cả',
				changeSkillTo: 'Đổi kỹ năng thành',
				changeAgentsSkill: 'Đổi kỹ năng của đại lý',
				totalAgents: 'Tổng đại lý',
				activeSkillAgents: 'Đại lý kỹ năng hoạt động',
				assignSkillToAgents: 'Gán kỹ năng cho đại lý',
				assignAgent: 'Gán đại lý',
				selectCapacityAndState: 'Chọn khả năng và trạng thái',
			},
			buckets: {
				buckets: 'Thùng chứa',
				allBuckets: 'Tất cả thùng chứa',
				addBucket: 'Thêm thùng chứa',
			},
			blacklist: {
				blacklist: 'Danh sách',
				allBlacklists: 'Tất cả danh sách',
				number: 'Số',
				newNumber: 'Số mới',
				numbersCount: 'Số lượng',
				expireAt: 'Hạn',
				temporary: 'Tạm thời',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
					description: ({ linked }) => linked('vocabulary.description'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
				},
				importResult:
					'Đã nhập {imported} số. Đã bỏ qua {skipped} số trùng lặp.',
			},
			media: {
				mediaFiles: 'Tệp phương tiện',
				allMediaFiles: 'Tất cả tệp phương tiện',
				createdAt: 'Đã tạo',
				format: 'Định dạng',
				size: 'Kích thước',
				textToSpeech: 'Dịch vụ chuyển đổi văn bản thành giọng nói',
				popupSettings: 'Cài đặt',
				lang: 'Ngôn ngữ',
				voice: 'Giọng nói',
				token: 'Mã thông báo',
				key: 'Khóa',
				dragPlaceholder: 'Kéo và thả các tệp',
				dragPlaceholderHere: 'ở đây.',
				tts: {
					hint: 'Tạo một tệp âm thanh',
					textType: {
						textType: 'Loại văn bản',
						ssml: 'SSML',
					},
				},
			},
			regions: {
				regions: 'Vị trí',
				allRegions: 'Tất cả vị trí',
			},
			timezone: {
				timezone: 'Múi giờ',
			},
			calendars: {
				calendars: 'Lịch',
				allCalendars: 'Tất cả lịch',
				searchPlaceholder: 'Tên, mô tả...',
				timezone: 'Múi giờ',
				start: 'Bắt đầu',
				end: 'Kết thúc',
				workWeek: 'Tuần làm việc',
				specialTime: 'Thời gian đặc biệt',
				holidays: 'Ngày lễ',
				date: 'Ngày',
				repeat: 'Lặp lại',
				fulltime: 'Tạm thời',
				everyYear: 'Lặp lại mỗi năm',
				newHoliday: 'Ngày lễ mới',
				mon: 'Thứ hai',
				tue: 'Thứ ba',
				wed: 'Thứ tư',
				thu: 'Thứ năm',
				fri: 'Thứ sáu',
				sat: 'Thứ bảy',
				sun: 'Chủ nhật',
				workingTime: 'Thời gian làm việc',
				workStart: 'Thời gian bắt đầu làm việc',
				workStop: 'Thời gian kết thúc làm việc',
			},
			communications: {
				communications: 'Loại liên lạc',
				allCommunications: 'Tất cả loại liên lạc',
				addCommunication: 'Thêm liên lạc',
				missingCommunication: 'Vui lòng thêm loại liên lạc',
				code: 'Mã',
				channels: {
					[EngineCommunicationChannels.Phone]: 'Điện thoại',
					[EngineCommunicationChannels.Email]: 'Email',
					[EngineCommunicationChannels.Messaging]: 'Tin nhắn',
				},
			},
			pauseCause: {
				pauseCause: 'Lý do tạm dừng',
				allPauseCause: 'Tất cả nguyên nhân tạm dừng đại lý',
				limit: 'Giới hạn (phút)',
				min: 'phút',
				allowAdmin: 'Quản trị viên có thể thay đổi trạng thái này',
				allowSupervisor: 'Giám sát có thể thay đổi trạng thái này',
				allowAgent: 'Đại lý có thể thay đổi trạng thái này',
			},
			quickReplies: {
				quickReplies: 'Trả lời nhanh',
			},
			activityTypes: {
				activityTypes: 'Loại hoạt động | Loại hoạt động',
			},
		},
		routing: {
			routing: 'Định tuyến',
			ip: 'IP',
			protocol: 'Giao thức',
			port: 'Cổng',
			configuration: 'Cấu hình',
			schema: 'Sơ đồ luồng',
			json: 'JSON',

			flow: {
				flow: 'Sơ đồ luồng',
				allFlowSchemas: 'Tất cả sơ đồ luồng',
				createFlowSelectionPopup: 'Tạo luồng mới',
				createNew: 'Tạo mới?',
				editor: 'Trình soạn thảo',
				diagram: {
					diagram: 'Biểu đồ',
					description: 'Tạo luồng mới bằng công cụ Webitel Flow Diagram',
				},
				code: {
					code: 'Mã',
					description: 'Tạo luồng mới bằng trình soạn thảo mã JSON-schema',
				},
				askingAlert:
					'Bạn có muốn lưu các thay đổi bạn đã thực hiện vào "{name}" ?',
			},

			dialplan: {
				dialplan: 'Lịch sử cuộc gọi',
				dialplanRules: 'Quy tắc lịch sử cuộc gọi',
				pattern: 'Số điện thoại đích',
				dialplanRule: 'Quy tắc lịch sử cuộc gọi',
				position: 'Vị trí',
				allowTransfer: 'Cho phép chuyển tiếp',
			},

			chatplan: {
				chatplan: 'Lịch sử trò chuyện',
				allChatplans: 'Tất cả lịch sử trò chuyện',
			},

			gateways: {
				gateways: 'Cổng',
				allGateways: 'Tất cả cổng',
				trunkingGateway: 'Cổng trunking',
				registerGateway: 'Cổng đăng ký',
				stateSuccess: 'Thành công',
				stateFailed: 'Thất bại',
				stateProgress: 'Đang thực hiện',
				stateNonreg: 'Chưa đăng ký',
				proxy: 'Proxy',
				searchPlaceholder: 'tìm kiếm cổng...',
				host: 'Host',
				trunkingACL: 'Danh sách kiểm soát truy cập trunking',
				hostnameTrunking: 'Tên Host/Cổng/IP của Server/Cổng',
				hostnameRegister: 'Tên Host/Server/Cổng/IP của Đăng ký/Server/Cổng',
				expire: 'Hạn',
				authID: 'Tên đăng nhập',
				account: 'Tài khoản',
				outboundProxy: 'Host/IP của Proxy xuất',
				newGateway: 'Cổng mới',
				newGatewayDescription: 'Mô tả cổng mới',
				SIPregistrations: 'Đăng ký SIP',
				SIPregistrationsDescription: 'Mô tả đăng ký SIP',
				SIPtrunking: 'Trunking SIP',
				SIPtrunkingDescription: 'Mô tả trunking SIP',
			},
			chatGateways: {
				templates: {
					templates: 'Mẫu',
					title: 'Tên của thành viên Workspace',
					close: 'Thông báo hoàn thành trò chuyện',
					join: 'Thông báo đại lý tham gia',
					left: 'Thông báo ngắt kết nối của đại lý',
					filePolicyFail: 'Định dạng tệp bị cấm',
				},
				chatGateways: 'Cổng trò chuyện',
				allChatGateways: 'Tất cả cổng trò chuyện',
				telegramBot: {
					telegramBot: 'Bot Telegram',
				},
				telegramApp: {
					telegramApp: 'Ứng dụng Telegram',
					signedAs: 'Bạn đã đăng nhập như',
					joinTelegram: 'Đăng nhập vào Telegram',
					signOut: 'Đăng xuất khỏi Telegram',
					metadata: {
						apiId: 'ID API',
						apiHash: 'Mã băm API',
					},
				},
				infobip: {
					infobip: 'Infobip',
				},
				messenger: {
					meta: 'Meta',
					addOrRemovePages: 'Thêm hoặc xóa trang',
					accounts: 'Tài khoản',
					metadata: {
						clientId: 'ID ứng dụng',
						clientSecret: 'Mật khẩu ứng dụng',
						apiVersion: 'Phiên bản API',
						apiVersionHint: 'Định dạng: vXX.X (ví dụ: v24.0)',
					},
					facebook: {
						pages: 'Trang Facebook',
						subscription: 'Đăng ký webhook',
					},
					instagram: {
						instagram: 'Instagram',
						comments: 'Theo dõi bình luận',
						mentions: 'Theo dõi đề xuất',
					},
					whatsapp: {
						whatsapp: 'Whatsapp',
						token: 'Mã thông báo',
						status: 'Trạng thái',
						number: 'Số điện thoại',
						review: 'Đánh giá',
					},
				},
				viber: {
					viber: 'Viber',
					style: {
						style: 'Kiểu',
						btnBackColor: 'Màu nền nút',
						btnFontColor: 'Màu chữ nút',
					},
				},
				webchat: {
					webchat: 'Trò chuyện web',
					copyCode: 'Sao chép mã cho trang web',
					copyCodeHint:
						'Bạn phải tạo lại và chèn mã Widget vào trang web sau mỗi lần thay đổi cài đặt Widget',
					metadata: {
						mediaMaxSize: 'Kích thước tệp truyền tải tối đa (MB)',
					},
					view: {
						view: 'Xem',
						borderRadius: 'Hình dạng nút',
						language: 'Ngôn ngữ',
						position: 'Vị trí',
						btnColor: 'Màu nút',
						logoUrl: 'URL logo',
						logoHint:
							"Định dạng logo được hỗ trợ là 'JPEG' hoặc 'PNG', 24x24px",
						rounded: 'Tròn',
						square: 'Hình vuông',
						right: 'Phải',
						left: 'Trái',
					},
					recaptcha: {
						recaptcha: 'reCAPTCHA',
						sitekey: 'Mã Site',
						secret: 'Mã bí mật',
						threshold: 'Ngưỡng',
						showFlag: 'Hiển thị biểu tượng reCAPTCHA',
					},
					chat: {
						chat: 'Trò chuyện',
						openTimeout: 'Thời gian mở',
						openTimeoutSec: 'Thời gian mở (giây)',
					},
					appointment: {
						appointment: 'Cuộc hẹn',
						days: 'Ngày',
						availableAgents: 'Đại lý có sẵn',
						showEmailField: 'Hiển thị trường email',
						showMessageField: 'Hiển thị trường tin nhắn',
						resultPageText: 'Văn bản trang kết quả',
						headingText: 'Văn bản tiêu đề',
						subheadingText: 'Văn bản phụ đề',
						showDefaultHeading:
							'Hiển thị tiêu đề và phụ đề mặc định trên trang kết quả',
					},
					alternativeChannels: {
						alternativeChannels: 'Kênh truyền thông khác',
						title: 'Kênh truyền thông',
						email: 'Email',
						whatsapp: 'WhatsApp',
						telegram: 'Telegram',
						messenger: 'Messenger',
					},
					call: {
						title: 'Cuộc gọi trực tuyến',
						url: 'Điểm cuối WebSocket',
					},
				},
				customChat: {
					customChat: 'Trò chuyện tùy chỉnh',
					customChatGateway: 'Cổng trò chuyện tùy chỉnh',
					appSecretHint: 'Thay đổi trường này sẽ ngắt tích hợp',
					metadata: {
						appSecret: 'Mật khẩu ứng dụng',
						callback: 'Bản gọi lại',
					},
				},
				uri: 'URI',
				newChatGateway: 'Cổng trò chuyện mới',
				metadata: {
					apiKey: 'Mã API',
					baseUrl: 'URL cơ sở',
					allowOrigin: 'Cho phép nguồn',
					readTimeout: 'Thời gian đọc (giây)',
					writeTimeout: 'Thời gian ghi (giây)',
					handshakeTimeout: 'Thời gian bắt tay (giây)',
					botName: 'Tên bot',
					telegramToken: 'Mã API BOT Telegram',
				},
			},

			callflow: {
				callflow: 'Luồng cuộc gọi',
			},
		},

		ccenter: {
			ccenter: 'Trung tâm liên hệ',

			agents: {
				agents: 'Đại lý',
				supervisors: 'Giám sát',
				admins: 'Quản trị viên',
				subordinates: 'Đại lý phụ',
				allAgents: 'Tất cả đại lý',
				chatCount: 'Số cuộc trò chuyện',
				taskCount: 'Số nhiệm vụ',
				progressiveCountValidator: 'Giá trị phải lớn hơn 1 hoặc để trống',
				extraChatCount: 'Số cuộc trò chuyện bổ sung',
				state: 'Trạng thái',
				isSupervisor: 'Giám sát',
				stateTime: 'Thời gian trạng thái',
				statusType: 'Loại trạng thái',
				addSkill: 'Thêm kỹ năng',
				editSkill: 'Sửa kỹ năng',
				statusHistory: 'Lịch sử trạng thái',
				historyState: 'Trạng thái',
				payload: 'Nguyên nhân',
				addSubordinate: 'Thêm đại lý phụ',
				historyChannel: 'Kênh',
				historyFrom: 'Từ',
				historyTo: 'Đến',
				historyDuration: 'Thời gian',
				emptyPopup: 'Vui lòng kiểm tra truy vấn bộ lọc',
				status: {
					online: 'Trực tuyến',
					offline: 'Ngoại tuyến',
					pause: 'Tạm dừng',
					breakOut: 'Thời gian ngoại tuyến',
				},
				wfm: 'WFM',
				workingConditions: 'Điều kiện làm việc',
				pauseTemplate: 'Mẫu tạm dừng',
				agentScreenControl: 'Kiểm soát màn hình đại lý',
				agentScreenControlHint:
					'Không thể tắt tính năng này khi cài đặt cho đội đang được bật',
			},

			auditors: {
				auditors: 'Kiểm toán viên',
			},

			teams: {
				teams: 'Đội',
				allTeams: 'Tất cả đội',
				strategy: 'Chiến lược',
				parameters: 'Tham số',
				maxNoAnswer: 'Số lượng hoạt động bỏ qua tối đa',
				callTimeout: 'Thời gian chấp nhận cuộc gọi',
				inviteChatTimeout: 'Thời gian chấp nhận cuộc trò chuyện',
				wrapUpTime: 'Thời gian đóng cuộc trò chuyện',
				noAnswerDelayTime: 'Thời gian chờ sau khi hoạt động bỏ qua',
				taskAcceptTimeout: 'Thời gian chấp nhận nhiệm vụ',
				strategies: {
					random: 'Ngẫu nhiên',
					fewestCalls: 'Đại lý với số cuộc gọi ít nhất',
					leastTalkTime: 'Đại lý với thời gian nói ít nhất',
					topDown: 'Từ trên xuống',
					roundRobin: 'Vòng tròn',
					roundRobinBucket: 'Thùng vòng tròn',
					longestIdleAgent: 'Đại lý với thời gian nghỉ dài nhất',
					skillCapacity: 'Theo cấp độ kỹ năng',
				},
				hooks: {
					eventTypes: {
						agentStatus: 'Trạng thái đại lý đã thay đổi',
					},
				},
				flows: {
					addFlowSchema: 'Thêm sơ đồ luồng',
					editFlowSchema: 'Sửa sơ đồ luồng',
				},
				supervisors: {
					addSupervisor: 'Thêm giám sát',
					editSupervisor: 'Sửa giám sát',
				},
				agents: {
					addAgent: 'Thêm đại lý',
					editAgent: 'Sửa đại lý',
				},
			},

			members: {
				members: 'Thành viên',
				allMembers: 'Tất cả thành viên',
				addMember: 'Thêm thành viên',
				destination: 'Đích',
				communications: 'Liên lạc',
				display: 'Số hiển thị',
				dtmf: 'DTMF',
				priority: ({ linked }) => linked('objects.memberPriority'),
				attempts: 'Lần thử',
				emptyWorkspace: 'Không tìm thấy thành viên nào',
				resetMembers: {
					resetMembers: 'Đặt lại thử',
					description: {
						question:
							'Bạn có chắc chắn muốn đặt lại các lần thử không thành công',
						all: ({ linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')} mà không có giới hạn ngày nào không?`,
						filtered: ({ named, linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')} từ\n${named('dateFrom')} đến ${named('dateTo')}\ndựa trên các bộ lọc đã áp dụng và kết quả tìm kiếm không?`,
						selected: ({ linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')} không?`,
					},
					descriptionCount: '{count} bản ghi sẽ bị ảnh hưởng.',
					emptyDescription:
						'Không có lần thử không thành công nào khớp với bộ lọc hiện tại. Không có gì để đặt lại.',
					reset: 'Đặt lại',
					successResetCount: 'Đặt lại thành công {count} thành viên',
				},
				exportMembers: {
					exportMembers: 'Xuất thành viên',
				},
				endCause: {
					abandoned: ({ linked }) => linked('objects.stopCause.abandoned'),
					timeout: ({ linked }) => linked('objects.stopCause.timeout'),
					cancel: ({ linked }) => linked('objects.stopCause.cancel'),
					success: ({ linked }) => linked('objects.stopCause.success'),
					failed: ({ linked }) => linked('objects.stopCause.failed'),
					missed: ({ linked }) => linked('objects.stopCause.missed'),
					expired: ({ linked }) => linked('objects.stopCause.expired'),
					canceledByTimeout: ({ linked }) =>
						linked('objects.stopCause.canceledByTimeout'),
				},
				csvMappingFields: {
					timezoneId: ({ linked }) => linked('date.timezone'),
					priority: ({ linked }) => linked('vocabulary.priority'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
					bucketId: 'Bucket',
					agentId: ({ linked }) => linked('objects.agent.agent'),
					variables: ({ linked }) => linked('vocabulary.variables'),
					destination: ({ linked }) => linked('vocabulary.destination'),
					commPriority: 'Độ ưu tiên loại giao tiếp',
					code: 'Mã',
					description: ({ linked }) => linked('vocabulary.description'),
					dtmf: 'DTMF',
				},
			},

			globalStateConfirmation: {
				title: 'Áp dụng thay đổi',
				message:
					'Các thay đổi sẽ được áp dụng cho {count} bản ghi. Bạn có chắc chắn?',
			},

			queues: {
				queues: 'Hàng đợi',
				allQueues: 'Tất cả hàng đợi',
				type: 'Loại',
				state: 'Trạng thái',
				active: 'Hoạt động',
				notActive: 'Không hoạt động',
				activeCalls: 'Cuộc gọi hoạt động',
				waiting: 'Đang chờ',
				ringtone: 'Nhạc chuông',
				priority: 'Ưu tiên',
				teams: 'Đội',
				tags: 'Thẻ',
				newQueue: 'Hàng đợi mới',
				saveBeforeAddingRecords:
					'Điền các trường bắt buộc của hàng đợi trước khi thêm bản ghi',
				blacklist: 'Danh sách dừng',
				resources: ({ linked }) => linked('objects.ccenter.res.res'),
				resourceGroups: ({ linked }) =>
					linked('objects.ccenter.resGroups.resGroups'),
				newQueueDescription: 'Mô tả hàng đợi mới',
				outboundIVRQueue: 'Hàng đợi IVR xuất',
				outboundIVR: 'IVR xuất',
				outboundIVRQueueDescription:
					'Một IVR xuất cho phép một tổ chức tự động tham gia khách hàng thông qua nhiều kênh như cuộc gọi thoại tự động, tin nhắn SMS, email hoặc bài đăng trên mạng xã hội bằng các thông báo cá nhân.',
				inboundQueue: 'Hàng đợi nhập',
				inboundQueueDescription:
					'Một hàng đợi nhập là nơi mà cuộc gọi đến được đặt trên giữ, trong một hàng đợi, trong khi họ đang chờ đợi để nói chuyện với một nhà tư vấn sống.',
				offlineQueue: 'Hàng đợi ngoại tuyến',
				offlineQueueDescription:
					'Một hàng đợi ngoại tuyến cho phép cuộc gọi đến có thể dừng chờ trên giữ, nhập số điện thoại của họ và nhận cuộc gọi lại ngay khi đến lượt họ.',
				previewDialer: 'Dialer xem trước',
				previewDialerDescription: 'Xem liên hệ trước khi tự động gọi tới họ.',
				progressiveDialer: 'Dialer tiến triển',
				progressiveDialerDescription:
					'Dialing tiến triển giảm thời gian lãng phí giữa các cuộc gọi bằng cách tự động gọi một số từ danh sách cuộc gọi ngay khi một đại lý trở nên có sẵn.',
				predictiveDialer: 'Dialer dự đoán',
				predictiveDialerDescription:
					'Một dialer dự đoán gọi nhiều số cùng một lúc. Ngay khi một khách hàng trả lời, một nhà tư vấn được kết nối với họ.',
				chatInboundQueue: 'Hàng đợi nhập trò chuyện',
				chatInboundQueueDescription:
					'Giống như hàng đợi nhập, nhưng với trò chuyện',
				imChatQueue: 'Hàng đợi trò chuyện IM',
				imChatQueueDescription:
					'Giống như hàng đợi trò chuyện, nhưng cho tin nhắn tức thời',
				inboundJobQueue: 'Hàng đợi nhiệm vụ nhập',
				inboundJobQueueDescription: 'Hàng đợi nhiệm vụ nhập',
				outboundJobQueue: 'Hàng đợi nhiệm vụ xuất',
				outboundJobQueueDescription: 'Hàng đợi nhiệm vụ xuất',
				strategy: 'Chiến lược',
				timezone: 'Múi giờ',
				callLimit: 'Giới hạn cuộc gọi',
				variables: 'Biến',
				members: 'Thành viên',
				params: 'Tham số',
				discardAbandonedAfter: 'Bỏ qua sau khi bỏ qua',
				maxIdleAgent: 'Thời gian chờ đại lý',
				maxIdleClient: 'Thời gian chờ khách hàng',
				maxIdleDialog: 'Thời gian chờ tối đa',
				timeoutWithNoAgents: 'Thời gian chờ khi không có đại lý',
				timeBaseScore: 'Điểm số dựa trên thời gian',
				endless: 'Vô hạn',
				stickyAgent: 'Đại lý dính',
				stickyAgentSec: 'Đại lý dính (giây)',
				autoAnswerTone: 'Âm thanh cảnh báo tự động',
				varKey: 'Khóa',
				varVal: 'Giá trị',
				endCause: ({ linked }) => linked('objects.stopCause.stopCause'),
				offeringAt: 'Đặt lịch tại',
				destination: 'Đích',
				expire: 'Hạn',
				originateTimeout: 'Thời gian xuất phát',
				maxAgentLine: 'Số dòng đại lý tối đa',
				maxAgentLose: 'Số cuộc gọi mất đại lý tối đa',
				minAttempts: 'Lần dự đoán tối thiểu',
				maxAbandonedRate: 'Tỷ lệ bỏ qua tối đa (%)',
				loadFactor: 'Hệ số tải',
				abandonRateAdjustment: 'Điều chỉnh tỷ lệ bỏ qua',
				playbackSilence: 'Âm thanh phát lại im lặng',
				targetAbandonedRate: 'Tỷ lệ bỏ qua mục tiêu (%)',
				maxWaitTime: 'Thời gian chờ tối đa',
				maxWaitingSize: 'Số lượng chờ tối đa',
				waitBetweenRetries: 'Chờ giữa các lần thử lại',
				waitBetweenRetriesDesc: 'Sắp xếp lại thử của thành viên theo giảm dần',
				strictCircuit: 'Mạch điện tử chặt chẽ',
				retryAbandoned: 'Thử lại bỏ qua',
				playbackFile: 'Tệp phát lại',
				timeout: 'Hết thời gian',
				maxNumberOfRetry: 'Số lần thử tối đa',
				minDuration: 'Thời gian cuộc gọi thành công tối thiểu',
				maxAttempts: 'Số lần thử tối đa',
				minOnlineAgents: 'Truy cập khi có nhiều đại lý trực tuyến hơn',
				waitForResultStatus: 'Đợi trạng thái kết quả',
				bucketPriority: 'Ưu tiên',
				amd: 'AMD',
				enabled: 'Sử dụng AMD',
				ai: 'Trí tuệ nhân tạo',
				positiveLabels: 'Nhãn dương',
				aiPlayback: 'Tệp phát lại',
				allowNotSure: 'Chuyển NOTSURE đến đại lý',
				silenceNotSure: 'Chuyển im lặng đến đại lý',
				allowGreetingAgent: 'Cho phép đại lý chào đón',
				preSchema: 'Sơ đồ tiền xử lý',
				afterSchema: 'Sơ đồ sau xử lý',
				maxCalls: 'Số nhiệm vụ tối đa',
				dialingRate: 'Tốc độ gọi',
				maxCallsHint: 'Nếu giá trị là 0, không thực hiện nhiệm vụ nào',
				recordings: 'Ghi âm',
				recordAll: 'Bắt đầu ghi âm sau khi trả lời',
				perNumbers: 'Lần thử gọi trên mỗi số điện thoại',
				maxWordLength: 'Độ dài từ tối đa (ms)',
				maxNumberOfWords: 'Số lượng từ tối đa',
				betweenWordsSilence: 'Im lặng giữa các từ (ms)',
				minWordLength: 'Độ dài từ tối thiểu (ms)',
				totalAnalysisTime: 'Thời gian phân tích tổng (ms)',
				silenceThreshold: 'Ngưỡng im lặng (ms)',
				afterGreetingSilence: 'Im lặng sau khi chào (ms)',
				greeting: 'Chào (ms)',
				initialSilence: 'Im lặng ban đầu (ms)',
				statisticTime: 'Khoảng thời gian tính toán lại',
				communications: 'Loại liên lạc',
				manualDistribution: 'Phân phối thủ công',
				lastMessageTimeout: 'Thời gian chờ từ tin nhắn cuối cùng',
				stickyIgnoreStatus: 'Bỏ qua trạng thái đại lý',
				ignoreCalendar: 'Bỏ qua lịch',
				resourceStrategy: {
					resourceStrategy: 'Chiến lược tài nguyên',
					priorityBased: 'Dựa trên ưu tiên',
					evenDistribution: 'Phân phối đều',
				},
				attemptsReset: {
					resetActiveAttempts: ({ linked }) =>
						linked('objects.permissions.roles.permissions.resetActiveAttempts'),
					title: 'Đặt lại thử',
					attemptType: 'Loại thử',
					idleTime: 'Thời gian nghỉ (phút)',
					result: ({ linked }) =>
						linked('objects.integrations.triggers.logs.result'),
					calls: 'Cuộc gọi',
					attemptsCount: 'Lượt thử',
				},
				processing: {
					processing: 'Đang xử lý',
					enabled: 'Đợi kết quả cuộc gọi',
					formSchema: 'Sơ đồ xử lý động',
					sec: 'Thời gian xử lý sau (giây)',
					renewalSec: 'Đề xuất kéo dài xử lý sau khi còn lại (giây)',
					allowProlongation: 'Cho phép kéo dài xử lý sau',
					autosave: 'Cho phép tự động lưu xử lý sau',
					repeatsNumber: 'Số lần lặp lại',
					prolongationTimeSec: 'Thời gian kéo dài (giây)',
					isTimeoutRetry: 'Thử lại cho đến hết thời gian chờ',
				},
				queueStrategy: {
					fifo: 'FIFO (First In First Out)',
					lifo: 'LIFO (Last In First Out)',
					strict_fifo: 'Strict FIFO (First In First Out)',
				},
				logs: {
					logs: 'Nhật ký',
					destination: 'Đích',
					offeringAt: 'Đặt lịch',
					joinedAt: 'Bắt đầu',
					leavingAt: 'Kết thúc',
					duration: ({ linked }) => linked('vocabulary.duration'),
					viewNumber: 'Số lượt xem',
					result: ({ linked }) => linked('objects.callReportingResult.result'),
					attempts: 'Lần thử',
					resultName: {
						abandoned: ({ linked }) =>
							linked('objects.callReportingResult.abandoned'),
						cancel: ({ linked }) =>
							linked('objects.callReportingResult.cancel'),
						success: ({ linked }) =>
							linked('objects.callReportingResult.success'),
						failed: ({ linked }) =>
							linked('objects.callReportingResult.failed'),
						missed: ({ linked }) =>
							linked('objects.callReportingResult.missed'),
						timeout: ({ linked }) =>
							linked('objects.callReportingResult.timeout'),
						endless: ({ linked }) =>
							linked('objects.callReportingResult.endless'),
						transferred: ({ linked }) =>
							linked('objects.callReportingResult.transferred'),
						shutdown: ({ linked }) =>
							linked('objects.callReportingResult.shutdown'),
					},
				},
				hooks: {
					hooks: 'Hook',
					event: 'Sự kiện',
					eventTypes: {
						joined: 'Tham gia',
						answered: 'Trả lời',
						offering: 'Đặt lịch',
						bridged: 'Kết nối',
						missed: 'Bỏ qua',
						leaving: 'Rời khỏi',
						processing: 'Đang xử lý',
						active: 'Hoạt động',
					},
				},
				skills: {
					editSkill: 'Sửa kỹ năng',
					addSkill: 'Thêm kỹ năng',
				},
				buckets: {
					addBucket: 'Thêm thùng chứa',
					editBucket: 'Sửa thùng chứa',
				},
			},

			res: {
				res: 'Tài nguyên',
				allRes: 'Tất cả tài nguyên',
				reserve: 'Đặt trước',
				searchPlaceholder: 'tên, cổng..',
				cps: 'CPS',
				limit: 'Giới hạn',
				cidType: 'Loại CID',
				ignoreEarlyMedia: 'Bỏ qua Media sớm',
				numbers: 'Số',
				displayNumbers: 'Số hiển thị',
				failure: 'Thất bại',
				maxErrors: 'Số lượng phản hồi thất bại tối đa',
				errorCodes: 'Phản hồi thất bại yêu cầu',
				patterns: 'Mẫu số điện thoại đích',
				priority: 'Ưu tiên',
				reserveResource: 'Đặt trước tài nguyên',
				failureDialDelay: 'Thời gian chậm gọi thất bại',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
				},
			},

			resGroups: {
				resGroups: 'Nhóm tài nguyên',
				allResGroups: 'Tất cả nhóm tài nguyên',
				searchPlaceholder: 'tên nhóm tài nguyên..',
				addResGroup: 'Thêm nhóm tài nguyên',
				editResGroup: 'Sửa nhóm tài nguyên',
				strategy: 'Chiến lược',
				timerange: 'Khoảng thời gian',
				timerangeFrom: 'Từ',
				timerangeTo: 'Đến',
			},
		},

		integrations: {
			integrations: 'Tích hợp',
			emptyWorkspace: 'Chưa có hồ sơ nào',

			storage: {
				storage: 'Lưu trữ',
				allStorages: 'Tất cả lưu trữ',
				type: 'Loại',
				maxSize: 'Dung lượng lưu trữ (GB)',
				expireDays: 'Thời hạn (ngày)',
				priority: 'Ưu tiên',
				newStorage: 'Lưu trữ mới',
				newStorageDescription: 'Mô tả lưu trữ mới',
				local: 'Cục bộ',
				s3: 'S3 Bucket',
				digitalOcean: 'Digital Ocean Spaces',
				backblaze: 'Backblaze B2',
				dropbox: 'Dropbox',
				drive: 'Google Drive',
				configuration: 'Cấu hình',
				pathPattern: 'Mẫu đường dẫn',
				localFolder: 'Thư mục cục bộ',
				s3Key: 'ID Khóa',
				s3Access: 'Khóa truy cập',
				bucket: 'Thùng chứa',
				region: 'Vùng',
				oceanKey: 'ID Khóa',
				oceanAccess: 'Khóa truy cập',
				backblazeAccount: 'ID Tài khoản',
				backblazeKey: 'Ứng dụng khóa',
				backblazeBucketId: 'ID Thùng chứa',
				dropboxKey: 'Mã thông báo truy cập',
				driveFolder: 'Tên thư mục',
				driveEmail: 'Email Google',
				driveKey: 'Khóa riêng tư',
				s3Endpoint: 'Điểm cuối',
			},

			storagePolicies: {
				storagePolicies: 'Chính sách lưu trữ',
				mimeTypes: 'Loại MIME',
				retentionDays: 'Số ngày lưu trữ',
				maxDownloadSpeed: 'Tốc độ tải xuống tối đa (kbps)',
				maxUploadSpeed: 'Tốc độ tải lên tối đa (kbps)',
				maxUploadSize: 'Kích thước tải lên tối đa (bytes)',
				applyToFiles: 'Áp dụng ngày lưu giữ cho các tệp hiện có',
				applyPopupMessage:
					'Thời hạn lưu trữ mới sẽ được áp dụng cho các tệp hiện có theo chính sách. Bạn có muốn tiếp tục?',
				channels: {
					[StorageUploadFileChannel.CallChannel]: 'cuộc gọi',
					[StorageUploadFileChannel.ChatChannel]: 'trò chuyện',
					[StorageUploadFileChannel.MediaChannel]: 'phương tiện',
					[StorageUploadFileChannel.MailChannel]: 'email',
					[StorageUploadFileChannel.LogChannel]: 'log',
					[StorageUploadFileChannel.ScreenRecordingChannel]: 'ghi màn hình',
				},
				encryptFile: 'Mã hóa tệp mới',
				encryptFileHint:
					'Bạn sẽ không thể giải mã tệp nếu khóa mã hóa bị mất! Bản ghi chỉ có thể truy cập qua API hoặc giao diện.',
				encryptionAlertTitle: 'Cảnh báo mã hóa',
				encryptionEnableMessage: 'Chỉ các tệp mới sẽ được mã hóa.',
				encryptionDisableMessage:
					'Các tệp cũ sẽ vẫn được mã hóa.\nCác tệp mới sẽ không được mã hóa.',
			},

			cognitiveProfiles: {
				cognitiveProfiles: 'Hồ sơ trí tuệ nhân tạo',
				properties: {
					region: 'Vùng',
					locale: 'Vùng miền',
				},
			},
			emailProfiles: {
				emailProfiles: 'Hồ sơ email',
				mailbox: 'Hộp thư',
				smtpPort: 'Cổng SMTP',
				imapPort: 'Cổng IMAP',
				smtpHost: 'Host SMTP',
				imapHost: 'Host IMAP',
				fetchInterval: 'Khoảng cách lấy mới',
				listen: 'Nghe',
				authType: 'Loại xác thực',
				authenticatedAs: 'Đã xác thực như',
			},
			singleSignOn: {
				singleSignOn: 'Hồ sơ SSO | Hồ sơ SSO',
				provider: 'Nhà cung cấp',
				clientId: 'Application (client) ID',
				clientSecret: 'Client secret',
				discoveryUrl: 'Discovery URL',
				scopes: 'Phạm vi',
				scopesPlaceholder: 'Nhập phạm vi và nhấn Enter',
				inspect: 'Inspect',
				inspectHint: 'Gửi yêu cầu tới nhà cung cấp và nhận token',
				token: 'Token',
				showToken: 'Hiển thị token',
				inspectDescription: 'Gửi yêu cầu tới nhà cung cấp và nhận token',
				mapping: 'Ánh xạ',
				mappingKeyHint:
					'Cung cấp thuộc tính người dùng (ví dụ: email, username, extension) làm khóa tìm kiếm.',
			},

			importCsv: {
				importCsv: 'Nhập CSV từ file | Nhập CSV từ file',
				allImportsCsv: 'Tất cả dữ liệu nhập từ các tệp CSV',
				source: 'Đích nhập',
				settings: 'Cài đặt',
				mappings: 'Bản đồ tên cột',
				mappingsHint:
					'Trong phần này, bạn nên cung cấp tên các cột trong tệp CSV dưới đây theo thứ tự tương ứng với nhãn của chúng',
				columnHeader: '{name} cột',
				members: {
					clearMembers: 'Xóa thành viên hiện có',
				},
			},

			tokens: {
				tokens: 'Mã thông báo',
				allTokens: 'Tất cả mã thông báo',
				expires: 'Hết hạn vào',
				popupMessage:
					'Tải xuống tệp khóa của bạn ngay bây giờ hoặc sao chép nó. Nếu bạn không tải tệp khóa ngay bây giờ, bạn sẽ không thể lấy lại mã thông báo của mình. Để bảo vệ an toàn của bạn, lưu trữ mã thông báo của bạn an toàn và không chia sẻ nó.',
				tokenCreated: 'Mã thông báo của bạn đã được tạo thành công!',
			},

			triggers: {
				triggers: 'Kích hoạt',
				allTriggers: 'Tất cả kích hoạt',
				type: 'Loại',
				schema: 'Sơ đồ',
				newTrigger: 'Kích hoạt mới',
				newTriggerDescription:
					'Chọn mẫu để bắt đầu hoặc bắt đầu từ một bảng trắng để vẽ. Chọn mẫu để bắt đầu hoặc bắt đầu từ một bảng trắng để vẽ.',
				event: 'Trên sự kiện',
				onEventDescription: 'Một lịch trình sơ đồ JSON Schema dựa trên sự kiện',
				cron: 'Tại thời gian',
				atTimeDescription:
					'Một lịch trình sơ đồ JSON Schema dựa trên thời gian',
				eventSelect: ({ linked }) =>
					linked('objects.ccenter.queues.hooks.event'),
				cases: 'Trường hợp',
				caseFiles: 'Tệp trường hợp',
				caseComments: 'Bình luận trường hợp',
				caseLinks: 'Liên kết trường hợp',
				call: 'Cuộc gọi',
				relatedCases: 'Trường hợp liên quan',
				expression: 'Biểu thức',
				timeout: 'Hết thời gian',
				resolutionTime: ({ linked }) => linked('cases.resolutionTime'),
				logs: {
					logs: 'Lịch sử chạy',
					startedAt: 'Bắt đầu',
					result: 'Kết quả',
				},
				recordCall: 'Ghi âm cuộc gọi',
				runTrigger: 'Chạy kích hoạt',
			},
		},
		system: {
			system: 'Hệ thống',
			changelogs: {
				changelogs: 'Nhật ký thay đổi',
				objects: 'Đối tượng',
				daysToStore: 'Số ngày lưu trữ',
				storage: 'Tải xuống',
				logs: {
					logs: 'Nhật ký',
					actions: 'Hoạt động',
					records: 'ID nhật ký',
					actionType: {
						[LoggerAction.Create]: 'Tạo',
						[LoggerAction.Delete]: 'Xóa',
						[LoggerAction.Update]: 'Sửa',
					},
				},
				period: {
					period: 'Khoảng thời gian',
					options: {
						daily: 'Hàng ngày',
						weekly: 'Hàng tuần',
						fortnightly: 'Hàng tháng',
						monthly: 'Hàng tháng',
					},
				},
			},
			configuration: {
				configuration: 'Cấu hình',
				parameter: 'Tham số',
			},
			globalVariables: {
				globalVariables: 'Biến toàn cầu',
				encrypted: 'Đã mã hóa',
				valueInfo: 'Nhập giá trị chỉ khi bạn muốn chỉnh sửa',
				newTitle: 'Biến toàn cầu mới',
				editTitle: 'Sửa biến toàn cầu',
			},
		},

		pagination: {
			rowsPerPage: 'Số hàng trên mỗi trang',
		},
	},

	filters: {
		team: 'Đội',
		queueType: 'Loại hàng đợi',
	},

	webitelUI: {
		filters: {
			tags: ({ linked }) => linked('vocabulary.tag'),
			joinedAt: ({ linked }) => linked('objects.joinedAt'),
			result: ({ linked }) => linked('objects.callReportingResult.result'),
			duration: ({ linked }) => linked('vocabulary.duration'),
		},
	},

	utils: {
		downloadFilesBtn: {
			downloadFiles: 'Tải xuống tệp',
			filesLoaded: 'Tệp đã tải',
			zippingProgress: 'Tiến trình nén',
		},
	},

	errorPages: {
		goToHome: 'Về trang chủ',
		page403: {
			title: 'Truy cập bị từ chối',
			text: 'Xin lỗi, bạn không có quyền để xem trang này.',
		},
		page404: {
			title: 'Có vẻ như bạn đã bị mất',
			text: 'Xin lỗi, chúng tôi không thể tìm thấy trang bạn muốn.',
		},
	},

	icon: {
		docs: 'Tài liệu',
		logout: 'Đăng xuất',
		account: 'Tài khoản',
		appNavigator: 'Bộ điều hướng ứng dụng',
		settings: 'Cài đặt',
	},

	iconHints: {
		upload: 'Tải lên',
		reload: 'Tải lại bảng',
		edit: 'Sửa',
		delete: 'Xóa',
		deleteAll: 'Xóa tất cả các mục',
		deleteSelected: 'Xóa {count} mục được chọn',
		deleteFiltered: 'Xóa tất cả các mục được lọc',
		resetAll: 'Đặt lại tất cả thành viên',
		resetSelected: 'Đặt lại {count} thành viên đã chọn',
		resetFiltered: 'Đặt lại tất cả thành viên đã lọc',
		generate: 'Tạo',
		add: 'Thêm',
		history: 'Lịch sử',
		download: 'Tải xuống',
		downloadAll: 'Tải xuống tất cả',
		draggable: 'Kéo thả',
		play: 'Phát',
		pause: 'Tạm dừng',
		resume: 'Tiếp tục',
		close: 'Đóng',
		change: 'Thay đổi',
		volume: 'Âm lượng',
		stop: 'Dừng',
		members: 'Thành viên',
		moveUp: 'Đưa lên',
		moveDown: 'Đưa xuống',
		nextPage: 'Trang tiếp theo',
		prevPage: 'Trang trước',
		expand: 'Mở rộng',
		collapse: 'Thu gọn',
	},
	errors: {
		invalidJson: 'JSON không hợp lệ',
	},
	reusable: {
		time: {
			t15m: '15 phút',
			t30m: '30 phút',
			t45m: '45 phút',
			t1h: '1 giờ',
			t3h: '4 giờ',
			t6h: '6 giờ',
		},
	},
};
